<template>
  <div>
    <table :style="getStyles" class="table">
      <thead :class="theadClass">
      <tr v-if="columns.length">
        <th v-for="item in columns"
            :key="item.field"
            :class="item.thClass"
            :style="item.thStyle"
            :width="item.width ? item.width : 'auto'">
          {{ item.title }}
        </th>
      </tr>
      <tr v-else>
        <th>
          No se han asignado cabeceras a la tabla
        </th>
      </tr>
      </thead>
      
      <tbody>
      <tr v-if="loading">
        <td :colspan="columns.length"
            class="align-middle text-center py-5">
              <span class="spinner-border text-primary spinner-border-sm"
                    role="status"></span>
          Cargando información...
        </td>
      </tr>
      
      <template v-if="!loading && data.length">
        <tr v-for="(row, index) in data"
            :key="row.id ? row.id : index">
          <td v-for="column in columns"
              :key="column.field"
              :class="column.tdClass"
              :style="column.tdStyle">
            <slot :name="column.field"
                  v-bind:column="column"
                  v-bind:index="index"
                  v-bind:row="row">
              {{ getRowData(row, column) }}
            </slot>
          </td>
        </tr>
      </template>
      
      <tr v-if="!loading && !data.length">
        <td :colspan="columns.length"
            class="align-middle text-center py-5">
          <i class="fas fa-exclamation-circle"></i> {{ emptyMessage }}
        </td>
      </tr>
      </tbody>
    </table>
    <paginator v-if="!loading && paginationData"
               :pagination-data="paginationData"
               @load-prev-page="loadPrevPage"
               @load-next-page="loadNextPage"
               @load-page="loadPage"></paginator>
  </div>
</template>

<script>
  import { AlertManager } from '../utils/AlertManager'
  import Paginator from './Paginator'
  
  export default {
    name: 'DynamicTable',
    components: {
      Paginator,
    },
    props: {
      columns: {
        type: Array,
        default: () => ([]),
      },
      data: {
        type: Array,
        default: () => ([]),
      },
      loading: {
        type: Boolean,
        default: true,
      },
      paginationData: {
        type: Object,
        default: () => ({}),
      },
      theadClass: {
        type: String,
        default: null,
      },
      emptyMessage: {
        type: String,
        default: 'No se encontraron resultados',
      },
      fixed: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      getRowData (row, column) {
        if (column.field.indexOf('.') !== -1) {
          const field = column.field.split('.')
          
          if (row[field[0]] && row[field[0]][field[1]]) {
            return row[field[0]][field[1]]
          }

          return null
        }
        
        return row[column.field]
      },
      async loadPrevPage (link) {
        try {
          const response = await axios.get(link)
          const {
                  data,
                  links,
                  meta,
                }        = response.data
          
          this.$emit('update-table-data', data, {
            links,
            meta,
          })
        } catch (e) {
          AlertManager.error(`Ocurrio un error al listar los datos.`)
        }
      },
      async loadNextPage (link) {
        try {
          const response = await axios.get(link)
          const {
                  data,
                  links,
                  meta,
                }        = response.data
          
          this.$emit('update-table-data', data, {
            links,
            meta,
          })
        } catch (e) {
          AlertManager.error(`Ocurrio un error al listar los datos.`)
        }
      },
      async loadPage (link) {
        try {
          const response = await axios.get(link)
          const {
                  data,
                  links,
                  meta,
                }        = response.data
          
          this.$emit('update-table-data', data, {
            links,
            meta,
          })
        } catch (e) {
          AlertManager.error(`Ocurrio un error al listar los datos.`)
        }
      },
    },
    computed: {
      getStyles () {
        if (this.fixed) {
          return {
            'table-layout': 'fixed',
          }
        }
        
        return {}
      },
      tableData () {
        return this.data
      },
    },
  }
</script>
